import storage from "store";
import {TENANT} from "@/store/mutation-types";
import request from '@/utils/request'

const api = {
  ssoUrl: "/sso/server/getSsoAuthUrl",
  ssoTicket: "/sso/server/getSsoTicket",
};

function getApiUrl (path) {
  const tenant = storage.get(TENANT)
  return process.env.VUE_APP_API_ADMIN_URL.replace("#tenant#", tenant) + path
}

export function getAuthorizeUrl(appId, redirectUrl) {
  return request({
    url: getApiUrl(api.ssoUrl),
    method: "get",
    params: {
      client: appId,
      redirectUrl: redirectUrl
    }
  })
}

/**
 * 获取sso ticket url
 *
 * @author lk
 * @date 2024/6/4 15:38
 **/
export function getSsoTicket(params){
  return request({
    url: getApiUrl(api.ssoTicket),
    method: 'get',
    params: params
  })
}
